import { render } from "./Contact.vue?vue&type=template&id=cd90b608"
import script from "./Contact.vue?vue&type=script&setup=true&lang=js"
export * from "./Contact.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"source/js/vue/pages/Contact.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cd90b608"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cd90b608', __exports__)) {
    api.reload('cd90b608', __exports__)
  }
  
  module.hot.accept("./Contact.vue?vue&type=template&id=cd90b608", () => {
    api.rerender('cd90b608', render)
  })

}


export default __exports__